const React = require('onyx-root/react')

module.exports = React
